module.exports = __webpack_public_path__ + "bcd339f0b7fc7f5d9552fead422acfee.pdf";